import PersonTags from './PersonTags';

export default PersonTags;
export { default as hasTags } from './hasTags';
